import { DEFAULT_FORM_MODEL as DEFAULT_REPORT_FORM_MODEL } from '../../constants';

export const MARKET_REPORT_CATEGORY_VALUE = 'intelligence';

export const MARKET_REPORT_OTHERS_VALUE = 'Others';

export const REPORT_FILE_LANGUAGE_OPTIONS = ['English', 'Chinese', 'Japanese', 'Korean'];

interface IMarketReportLocationOption {
  text: string;
  textCN: string;
  value: string;
  children?: IMarketReportLocationOption[];
}

export const LOCATION_OPTIONS: IMarketReportLocationOption[] = [
  {
    text: 'Market Reports',
    textCN: '市场报告',
    value: MARKET_REPORT_CATEGORY_VALUE,
    children: [
      { text: 'DataBrain', textCN: 'DataBrain', value: 'Newzoo' },
      { text: 'Sensor Tower', textCN: 'Sensor Tower', value: 'Sensor Tower' },
      { text: 'AppMagic', textCN: 'AppMagic', value: 'AppMagic' },
      { text: 'Other Vendors', textCN: 'Other Vendors', value: 'Ampere' },
      { text: 'VGI', textCN: 'VGI', value: 'VGI' },
      { text: 'Stream Hatchet', textCN: 'Stream Hatchet', value: 'Stream Hatchet' },
      {
        text: 'Others',
        textCN: 'Others',
        value: MARKET_REPORT_OTHERS_VALUE,
        children: [
          { text: 'data.ai', textCN: 'data.ai', value: 'data.ai' },
          { text: 'NPD', textCN: 'NPD', value: 'NPD' },
          { text: 'Statista', textCN: 'Statista', value: 'Statista' },
          { text: 'Famitsu', textCN: 'Famitsu', value: 'Famitsu' },
          { text: 'Twitter', textCN: 'Twitter', value: 'Twitter' },
          { text: 'Fandom', textCN: 'Fandom', value: 'Fandom' },
        ],
      },
    ],
  },
];

export const DEFAULT_FORM_MODEL: IReportFormModel = {
  ...DEFAULT_REPORT_FORM_MODEL,
  file_language: '',
};
